/**
 * Created by User on 17/02/2016.
 */
import Observer from '../utils/Observer';
import AdConsts from '../AdConsts';
import LiveAdPlugin from '../plugins/LiveAdPlugin';
import Block from './Block';
import BlockMember from './BlockMember';

export default Playlist;

function Playlist() {
  var _blocks = [];
  var _currentBlock = null;
  var _lastCompleteTime = null;
  var _pauseStartTimestamp = 0;
  var _disposed = false;
  var _skipAd = Observer.getObserverInstance().get(AdConsts.SKIP_AD);
  var _self = this;
  Observer.on('property:' + AdConsts.SKIP_AD, _onSkipAdChange);

  this.dispose = function() {
    Observer.off([ AdConsts.BLOCK_STARTED, AdConsts.BLOCK_ENDED ], _onBlockEvent);
    _self.stopCurrentBlock();
    for (var i = 0, l = _blocks.length; i < l; ++i) {
      _blocks[i].dispose();
    }
    _blocks = [];
    _currentBlock = null;
    _lastCompleteTime = null;
    _disposed = true;
  };

  this.processPlaylistData = function(data) {
    _disposed = false;
    var i;
    if (data) {
      var rawAdlist = null;
      if (data['Adlist']) {
        rawAdlist = data['Adlist'];
      } else if (data['result'] === 'ok' && data['data']) {
        rawAdlist = data['data'];
      } else {
        Observer.emit(AdConsts.PLAYLIST_ERROR);
      }
      if (rawAdlist) {
        var validatedAdlist = [];
        for (i = 0; i < rawAdlist.length; ++i) {
          if (rawAdlist[i].urls && rawAdlist[i].urls.length > 0) {
            validatedAdlist.push(rawAdlist[i]);
          }
        }

        _parsePlaylist(validatedAdlist);
        var blocksInfo = [];
        for (i = 0; i < _blocks.length; ++i) {
          blocksInfo[i] = {
            type: _blocks[i].type,
            timeout: _blocks[i].timeout,
            timeStart: _blocks[i].timeStart,
            timeEnd: _blocks[i].timeEnd,
            videoState: _blocks[i].videoState,
            timeUnit: _blocks[i].timeUnit,
          };
        }
        Observer.emit(AdConsts.PLAYLIST_READY);
        Observer.emit(AdConsts.PLAYLIST_INFO, blocksInfo.length > 0 ? blocksInfo : null);
        if (blocksInfo.length > 0) {
          Observer.getObserverInstance().set(AdConsts.PLAYLIST_INFO, blocksInfo);
        }
      }
    } else {
      Observer.emit(AdConsts.PLAYLIST_ERROR);
    }
  };

  this.run = function(state, currentTime, duration, customType, sizeInfo) {
    //skip if ad already running
    if (_currentBlock || _skipAd) {
      return;
    }
    var isLiveAd = LiveAdPlugin && LiveAdPlugin.isLiveAd;
    var timestampCurrentTime;
    var usedCurrentTime;

    duration = duration === Number.POSITIVE_INFINITY ? Number.MAX_SAFE_INTEGER : duration; // safari live

    if (isLiveAd) {
      //avoid preroll
      if (currentTime != 0 && duration != 1) {
        timestampCurrentTime = LiveAdPlugin.startTimestamp + currentTime;
        if (Observer._observer && Observer._observer.config.debug) {
          console.log('%c' + new Date(timestampCurrentTime * 1000), 'color: red');
        }
      }
    }
    if (state === AdConsts.STATE_PAUSE) {
      _pauseStartTimestamp = new Date().getTime() / 1000;
    }
    var block;
    var blockStartTime, blockEndTime;
    var isCompletePostrollSkipped = false;
    for (var i = 0, l = _blocks.length; i < l; ++i) {
      block = _blocks[i];
      if (state !== block.videoState) {
        continue;
      }
      if (customType && customType !== block.type) {
        continue;
      }
      if (block.timeUnit === AdConsts.PERCENT) {
        blockStartTime = block.timeStart * duration / 100;
        blockEndTime = block.timeEnd * duration / 100;
      } else {
        blockStartTime = block.timeStart;
        blockEndTime = block.timeEnd;
      }

      if (state === AdConsts.STATE_COMPLETE) {
        blockStartTime = 0;
        blockEndTime = duration;
      }

      if ((block.type == AdConsts.MIDROLL || block.type == AdConsts.POSTROLL) && state != AdConsts.STATE_COMPLETE) {
        if (blockStartTime > Block.SECONDS_TO_START) {
          blockStartTime -= Block.SECONDS_TO_START;
        }
      }

      if (isLiveAd && block.timeUnit === AdConsts.SECONDS) {
        usedCurrentTime = timestampCurrentTime;
      } else {
        usedCurrentTime = currentTime;
      }

      if (blockStartTime <= usedCurrentTime && blockEndTime >= usedCurrentTime && !block.showed) {
        if (block.type === AdConsts.AFTER_PAUSE_ROLL) {
          var timestamp = new Date().getTime() / 1000;
          if (block.minPauseDuration > 0 && (timestamp - _pauseStartTimestamp) < block.minPauseDuration) {
            break;
          }
        }

        var isPostrollOnComplete = state == AdConsts.STATE_COMPLETE && block.type == AdConsts.POSTROLL;
        var isAbleToShow = isPostrollOnComplete || !_isSkipBlockByLocalTimeout(block);
        if (isAbleToShow) {
          isAbleToShow = !_isSkipBlockByGlobalTimeout(block);
        }

        if (isAbleToShow) {
          _currentBlock = block;
          Observer.on([ AdConsts.BLOCK_STARTED, AdConsts.BLOCK_ENDED ], _onBlockEvent);
          block.show(sizeInfo);
        } else if (!isAbleToShow && block.type === AdConsts.PREROLL) {
          Observer.emit(AdConsts.BLOCK_ENDED, block);
        } else if (state === AdConsts.STATE_COMPLETE && block.type === AdConsts.POSTROLL) {
          // postroll is skipped by global timeout
          isCompletePostrollSkipped = true;
          Observer.emit(AdConsts.BLOCK_ENDED, block);
        }
        break;
      }
    }
    if (state === AdConsts.STATE_COMPLETE && !_currentBlock && !isCompletePostrollSkipped) {
      Observer.emit('player:completed');
    }
  };

  this.currentMemberCompleted = function() {
    if (_currentBlock) {
      _currentBlock.currentMemberCompleted();
    }
  };

  this.stopCurrentBlock = function() {
    if (_currentBlock) {
      _currentBlock.stopBlock();
    }
  };

  this.getMembersCount = function(member) {
    var result = 0;
    for (var i = 0, l = _blocks.length; i < l; ++i) {
      if (_blocks[i].type == member.type && _blocks[i].timeStart == member.timeStart) {
        result = _blocks[i].getMembersCount(member);
        break;
      }
    }
    return result;
  };

  this.getMemberNumber = function(member) {
    var result = -1;
    for (var i = 0, l = _blocks.length; i < l; ++i) {
      if (_blocks[i].type == member.type && _blocks[i].timeStart == member.timeStart) {
        result = _blocks[i].getMemberNumber(member);
        break;
      }
    }
    return result;
  };

  this.getBlockByType = function(blockType) {
    var result = [];
    for (var i = 0, l = _blocks.length; i < l; ++i) {
      if (_blocks[i].type === blockType) {
        result.push(_blocks[i]);
      }
    }
    return result;
  };

  var _parsePlaylist = function(playlistArray) {
    var blockMember, j, k, foundValidBlock;
    for (var i = 0, l = playlistArray.length; i < l; ++i) {
      blockMember = _processMember(playlistArray[i]);
      foundValidBlock = false;
      for (j = 0, k = _blocks.length; j < k; ++j) {
        if (isValidMember(_blocks[j], blockMember)) {
          _blocks[j].addAdPlaylistElement(blockMember);
          foundValidBlock = true;
          break;
        }
      }
      if (!foundValidBlock) {
        _blocks.push(new Block(
          blockMember.videoState, blockMember.type,
          blockMember.timeStart, blockMember.timeEnd,
          blockMember.timeUnit, blockMember.timeout
        ));
        _blocks[_blocks.length - 1].addAdPlaylistElement(blockMember);
      }
    }
  };

  var _isSkipBlockByLocalTimeout = function(block) {
    var result = true,
      nowDateTime = new Date().getTime();
    // check for local timeout
    if (block.timeout == 0) {
      result = false;
    } else if (block.type == AdConsts.OVERLAY || block.type == AdConsts.PAUSE_ROLL) {
      result = false;
    } else if (!_lastCompleteTime) {
      result = false;
    } else if (nowDateTime - _lastCompleteTime.getTime() > block.timeout * 1000) {
      result = false;
    }

    return result;
  };

  var _isSkipBlockByGlobalTimeout = function(block) {
    var result = false;
    var globalTimeouts = Observer.getObserverInstance().get(AdConsts.PROP_GLOBAL_TIMEOUTS);
    if (globalTimeouts) {
      var globalTimeoutByType = globalTimeouts[block.type];
      if (globalTimeoutByType) {
        result = Date.now() <= globalTimeoutByType;
      }
    }
    return result;
  };

  var _onBlockEvent = function(event) {
    switch (event.name) {
      case AdConsts.BLOCK_STARTED:
        break;
      case AdConsts.BLOCK_ENDED:
        Observer.off([ AdConsts.BLOCK_STARTED, AdConsts.BLOCK_ENDED ], _onBlockEvent);
        if (!_currentBlock.errorInBlock) {
          _lastCompleteTime = new Date();
        }
        _currentBlock = null;
    }
  };

  function _onSkipAdChange(event) {
    _skipAd = !!event.data;
  }

  function isValidMember(block, member) {
    return block.type == member.type && block.timeStart == member.timeStart
			&& block.timeEnd == member.timeEnd && block.videoState == member.videoState
			&& block.timeUnit == member.timeUnit;
  }

  Object.defineProperties(this, {
    'blocks': {
      enumerable: true,
      configurable: true,
      get: function() {
        return _blocks;
      }
    },
    'currentBlock': {
      enumerable: true,
      configurable: true,
      get: function() {
        return _currentBlock;
      }
    },
    'hasPreroll': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = false;
        for (var i = 0, l = _blocks.length; i < l; ++i) {
          if (_blocks[i].type == AdConsts.PREROLL) {
            result = _blocks[i].membersCount > 0 && _blocks[i].timeStart == 0;
            break;
          }
        }
        return result;
      }
    },
    'disposed': {
      enumerable: true,
      configurable: false,
      get: function () {
        return _disposed;
      }
    }
  });

  var _processMember = function(memberData) {
    var member = new BlockMember();
    member.timeStart = parseInt(memberData['time_start']);
    member.timeEnd = parseInt(memberData['time_end']);
    member.timeUnit = memberData['time_unit'] ? memberData['time_unit'].toUpperCase() : AdConsts.SECONDS;
    member.videoState = memberData['video_state'] ? memberData['video_state'].toUpperCase() : memberData['video_state'];
    member.priority = parseInt(memberData['priority']) || 1;
    member.timeout = parseInt(memberData['timeout']) || 0;
    member.globalTimeout = memberData['global_timeout'] || 0;
    member.type = memberData['type'] ? memberData['type'].toLowerCase() : memberData['type'];
    member.urls = memberData['urls'];
    member.minPauseDuration = memberData['min_pause_duration'];
    member.repeatInterval = memberData['repeat_interval'];
    member.blockEnd = memberData['block_end'] || -1;
    return member;
  };

}
Playlist.prototype.constructor = Playlist;
